/*eslint-disable*/
import { useEffect, useRef, useState } from 'react';
import type { ElementType, FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { subHours } from 'date-fns';
import {
  Avatar,
  Badge,
  Box,
  Button,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useAuth from '../../hooks/useAuth';
import useIndicators from 'src/hooks/useIndicators';
import BellIcon from '../../icons/Bell';
import ChatAltIcon from '../../icons/ChatAlt';
import CreditCardIcon from '../../icons/CreditCard';
import ShoppingCartIcon from '../../icons/ShoppingCart';

interface Notification {
  id: string;
  title: string;
  description: string;
  type: string;
  createdAt: number;
  href: string;
}

const now = new Date();

let notificationsBell: Notification[] = [];

const iconsMap: Record<string, ElementType> = {
  item_shipped: ShoppingCartIcon,
  new_message: ChatAltIcon,
  order_placed: CreditCardIcon,
};

const NotificationsPopover: FC<any> = (props) => {
  const { user } = useAuth();
  const { t } = useTranslation('navbar');
  const { notifications: indicator, getNotifications } = useIndicators();
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [numberNotification, setNumberNotification] = useState(0);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleAllRead = (): void => {
    setNumberNotification(0);
  };

  const getNotificationsCall = async () => {
    await getNotifications();
  };

  useEffect(() => {
    if (user['rolDesc'] === 'master') {
      getNotificationsCall();
    }
  }, []);

  useEffect(() => {
    notificationsBell = [];
    if (
      indicator !== null &&
      indicator !== undefined &&
      indicator.length !== 0
    ) {
      if (user.businessId?.flag_contract && user.rolDesc === 'master') {
        notificationsBell.push({
          id: 'contract',
          createdAt: subHours(now, 2).getTime(),
          description:
            'Completa el contrato para continuar aprovechando los beneficios de Release.',
          title: 'Contrato',
          type: 'new_message',
          href: 'dashboard/contract',
        });
      }
      if (
        indicator['etl'][`totalActivo`] === '0' &&
        indicator['etl'][`totalPasivo`] === '0' &&
        indicator['etl'][`totalIngreso`] === '0' &&
        indicator['etl'][`totalPatrimonio`] === '0' &&
        indicator['etl'][`totalCosto`] === '0'
      ) {
        notificationsBell.push({
          id: '1',
          createdAt: subHours(now, 2).getTime(),
          description:
            'El archivo de Plan de Cuentas está vacío. Puedes continuar gestionando pagos sin ningún inconveniente.',
          title: 'Documento de Plan de Cuentas',
          type: 'new_message',
          href: 'settings',
        });
      }

      if (indicator['etl'][`totalTransaccion`] === '0') {
        notificationsBell.push({
          id: '2',
          createdAt: subHours(now, 2).getTime(),
          description:
            'El archivo de Transacciones está vacío. Puedes continuar gestionando pagos sin ningún inconveniente.',
          title: 'Documento de Transacciones',
          type: 'new_message',
          href: 'settings',
        });
      }

      if (indicator['etl'][`totalDocumento`] === '0') {
        notificationsBell.push({
          id: '3',
          createdAt: subHours(now, 2).getTime(),
          description:
            'El archivo de Documentos está vacío. Puedes continuar gestionando pagos sin ningún inconveniente.',
          title: 'Archivo de Documentos',
          type: 'new_message',
          href: 'settings',
        });
      }

      if (indicator['etl'][`totalBg`] === '0') {
        notificationsBell.push({
          id: '4',
          createdAt: subHours(now, 2).getTime(),
          description:
            'El archivo de Balance está vacío. Puedes continuar gestionando pagos sin ningún inconveniente.',
          title: 'Documento de Balance',
          type: 'new_message',
          href: 'settings',
        });
      }

      if (indicator['etl'][`totalEr`] === '0') {
        notificationsBell.push({
          id: '5',
          createdAt: subHours(now, 2).getTime(),
          description:
            'El archivo de Estado está vacío. Puedes continuar gestionando pagos sin ningún inconveniente.',
          title: 'Documento de Estado',
          type: 'new_message',
          href: 'settings',
        });
      }
    }
    setNumberNotification(notificationsBell.length);
  }, [indicator]);

  return (
    <>
      <Tooltip title={t('notification.title')}>
        <IconButton color="primary" ref={anchorRef} onClick={handleOpen}>
          <Badge color="error" badgeContent={numberNotification}>
            <BellIcon fontSize="small" />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: 320 },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography color="textPrimary" variant="h6">
            {t('notification.title')}
          </Typography>
        </Box>
        {notificationsBell.length === 0 ? (
          <Box sx={{ p: 2 }}>
            <Typography color="textPrimary" variant="subtitle2">
              {t('notification.none')}
            </Typography>
          </Box>
        ) : (
          <>
            <List disablePadding>
              {notificationsBell.map((notification) => {
                const Icon = iconsMap[notification.type];
                return (
                  <ListItem divider key={notification.id}>
                    <ListItemAvatar>
                      <Avatar
                        sx={{
                          backgroundColor: 'primary.main',
                          color: 'primary.contrastText',
                        }}
                      >
                        <Icon fontSize="small" />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Button
                          component={RouterLink}
                          to={notification.href}
                          sx={{
                            marginLeft: -1,
                          }}
                        >
                          {notification.title}
                        </Button>
                        // <Link
                        //   href={notification.href}
                        //   color="textPrimary"
                        //   sx={{ cursor: 'pointer' }}
                        //   underline="none"
                        //   variant="subtitle2"
                        // >
                        //   {notification.title}
                        // </Link>
                      }
                      secondary={notification.description}
                    />
                  </ListItem>
                );
              })}
            </List>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                p: 1,
              }}
            >
              <Button
                color="primary"
                size="small"
                variant="text"
                onClick={handleAllRead}
              >
                {t('notification.all-read')}
              </Button>
            </Box>
          </>
        )}
      </Popover>
    </>
  );
};

export default NotificationsPopover;
